import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT,Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';

import * as Sentry from '@sentry/angular';

import { WINDOW } from '@personal-area/common';

import { UsabillaEventName } from './models/usabilla.interface';

@Injectable({
  providedIn: 'root',
})
export class UsabillaService {
  private readonly _window = inject(WINDOW);

  constructor(
    @Inject(PLATFORM_ID) private readonly _platformId: object,
    @Inject(DOCUMENT) private readonly _document: Document,
  ) {
  }

  public isEnabled(): boolean {
    return (
      isPlatformBrowser(this._platformId) &&
      Boolean(this._window['usabilla_live'])
    );
  }

  public executeEvent(command: UsabillaEventName, ...args: unknown[]): void {
    if (!this.isEnabled()) {
      Sentry.captureException(
        new Error(`Usabilla not available, skipping '${command}'`),
        { tags: { component: 'GetFeedbackService' } },
      );
      return;
    }

    try {
      this._window['usabilla_live']?.(command, ...args);
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'GetFeedbackService' },
      });
    }
  }
}
